/**
 * Property Address Form Section
 * Collects the address where the manufactured home will be placed.
 */

import { DomainAddressType } from "@porchpass/api-client";
import * as React from "react";
import { FormTable, FormTableBody } from "@porchpass/ui";
import { MapsLocation02Icon } from "@porchpass/ui";
import { HomeFields } from "@porchpass/ui";
import { useApplicationFormStore } from "../hooks/useApplicationFormStore";
import type { Address } from "../types/applicationTypes";

export const PropertyAddressForm: React.FC = () => {
  const store = useApplicationFormStore();
  const land = store.data.land;
  const address: Address = land.propertyAddress || {
    street: "",
    city: "",
    state: "",
    zipCode: "",
    type: DomainAddressType.AddressCurrent,
    isMailingAddress: false,
  };
  const googlePlacesApiKey = __GOOGLE_PLACES_API_KEY__;

  const errors = React.useMemo(() => {
    const result: Record<string, string> = {};
    const prefix = "land.propertyAddress.";
    for (const [key, value] of Object.entries(store.fieldErrors)) {
      if (key.startsWith(prefix) && value) {
        result[key.slice(prefix.length)] = value;
      }
    }
    return result;
  }, [store.fieldErrors]);

  return (
    <div className="space-y-6">
      <FormTable
        title="Property Address"
        subtitle="Where will the home be placed"
        headerIcon={
          <MapsLocation02Icon
            variant="bulk-rounded"
            size={16}
            className="text-[#CA7900]"
          />
        }
      >
        <FormTableBody>
          <HomeFields
            value={{
              homeType: "",
              primaryUse: "",
              propertyAddress: address,
            }}
            onChange={(patch) => {
              if (patch.propertyAddress) {
                store.updateLand({
                  propertyAddress: {
                    ...address,
                    ...patch.propertyAddress,
                  },
                });
              }
            }}
            errors={errors}
            showPlacementSection
            showGooglePlaces={!!googlePlacesApiKey}
            googlePlacesApiKey={googlePlacesApiKey}
          />
        </FormTableBody>
      </FormTable>
    </div>
  );
};

export default PropertyAddressForm;
